export { default } from './SelectCategory';



// WEBPACK FOOTER //
// ./src/components/write/SelectCategory/index.js